<template>
    <!-- <h2 class="ml-6" style="color: #2C3843">Cancelar Toca</h2> -->
  <v-card class="mx-0">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-toolbar
        color="#286090"
        dark
      >
        <img src="@/assets/logo_nuevo.png" style="width:50px;height:51px" class="mr-4">
        <h2>CANCELAR</h2>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="mt-9" v-if="roleUser == 'magistrado'">
        <v-row>
          <v-col
            cols="12"
            sm="12"
            class="mt-n6"
          >
            <v-toolbar
              color="#E0E0E0"
              dense
              flat
            >
              <h3 class="font-weight-bold" style="color: #0D47A1">Motivos de la Cancelación</h3>
            </v-toolbar>
            <vue-editor
              v-model="motivos"
              outlined
              name="input-7-4"
              placeholder="Ingrese los motivos..."
              required
            ></vue-editor>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn
            class="mb-2"
            color="red darken-1"
            text
            @click="close()"
          >
            Cerrar
          </v-btn>
          <v-btn
            class="mb-2  white--text"
            color="green darken-1"
            text
            :loading="loading"
            :disabled="!valid"
            @click="validate()"
          >
            GUARDAR
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";

  export default {
    props: {
      cuenta_id: {
        required: true
      },
      source: String
    },
    data(){
      return{
        motivos:'',
        valid: false,
        loading: false,
        apelacion: null,
        cuenta: {},
        active_tab: {},
      }
    },
    computed: {
      formTitle () {
        return 'Add Observación'
      },
      ...mapGetters(["currentUser", "roleUser"]),
    },
    mounted() {
      // this.getCuenta()
      // setTimeout(function () {
      //   var element = document.getElementById("focusOnElement");
      //   window.scrollTo({
      //     top: element.offsetTop,
      //     behavior: 'smooth'});
      // }.bind(this), 1000);
    },
    methods:{
      validate() {
        if (this.$refs.form.validate()) {
          if (!this.motivos) {
            this.$swal({
              title: "Error",
              text: "Favor de agregar motivos",
              icon: "warning",
              confirmButtonText: "Aceptar"
            });
            return false;
          }
          this.loading = true;
          this.save();
        }
      },
      save() {
        var data = {
          cuenta_id:this.cuenta_id,
          motivos: this.motivos,
        }
        var url;
        // if (this.roleUser == 'Magistrado') {
          url = '/cuenta/'+this.cuenta_id+'/cancela';
        // }
        this.$store.dispatch("CREATE_OBSERVACION", { url: url, data:data })
        .then(response => {
            this.loading = false;
            if (response.data.status == "ok") {
              this.$swal({
                title: "Éxito!!!",
                text: "Cancelada correctamente.",
                icon: "success",
                confirmButtonText: "Aceptar"
              });
            }
            // this.getCuenta()
            this.$router.push({ name:'Tocas', params: {
                title: this.active_tab.title,
                value: Number(this.active_tab.value),
                icon: this.active_tab.icon
              }
            })
          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "No se pudo guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
            this.$router.push('/tocas')
          });
      },
      close () {
        this.motivos = '';
        this.$emit('close', false)
      },
    }
  }
</script>

<style media="screen">
  .theme--light.v-input input, .theme--light.v-input textarea {
    color: rgb(62 61 61 / 87%);
  }
  .table {
    border-collapse:collapse;
    width: 100%;
  }

  .format_table {
    /* border: 1px solid #dddddd; */
    text-align: left;
    padding: 8px;
  }
</style>
